import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {CurrentUserGQL, User} from '../../generated/graphql';
import {UserService} from './user.service';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate {

    constructor(private router: Router,
                private userService: UserService,
                private currentUserGQL: CurrentUserGQL) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const roles: string[] = (route.data && route.data.roles) || [];

        // 1. Sem token → usuário não autenticado: manda para /login.
        //    (NÃO repetir o bug do AuthGuard, que retorna true mesmo sem token.)
        if (!this.userService.getStatusAuthenticated()) {
            this.router.navigate(['/login']);
            return false;
        }

        // 2. Perfil já hidratado (navegação normal, após o UserResolver do MainComponent):
        //    decide sincronamente.
        const current = this.userService.getUserLocal();
        if (current && current.profile) {
            return this.checkRole(current.profile, roles);
        }

        // 3. Deep-link / F5 direto na URL: o guard roda antes do UserResolver e o usuário
        //    ainda não está em memória. Busca o usuário atual pelo MESMO caminho do
        //    UserResolver (CurrentUserGQL) e hidrata o UserService antes de decidir.
        return this.currentUserGQL.fetch().pipe(
            take(1),
            map(({data}) => {
                const user = data.currentUser as User;
                this.userService.updateUser(user, false);
                return this.checkRole(user.profile, roles);
            }),
            catchError(() => {
                this.router.navigate(['/login']);
                return of(false);
            })
        );
    }

    private checkRole(profile: string, roles: string[]): boolean {
        if (roles.indexOf(profile) !== -1) {
            return true;
        }
        // Autenticado, porém sem permissão: volta para a home (NÃO para /login).
        this.router.navigate(['/']);
        return false;
    }
}
